var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.repos),function(repo){return _c('Repo',{key:repo.id,attrs:{"repo":repo}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }